import {
  SearchServicesResponse,
  CursorSearch,
} from './src/bookings-services-v2-service-services.universal';

export * from './src/bookings-services-v2-service-services.universal.js';

/** @hidden */
export type ServiceSearch = {};

/**
 * Retrieves a list of up to 100 services, given the provided filtering, paging,
 * and sorting.
 *
 *
 * ### Defaults
 *
 * Search Services has the following default settings, which you can override:
 * + Sorted by `createdDate` in ascending order.
 * + `paging.limit` set to `100`.
 * + `paging.offset` set to `0`.
 *
 * ### Filters
 *
 * When using filters for dates, you must use
 * [UTC time](https://en.wikipedia.org/wiki/Coordinated_Universal_Time).
 *
 * ### See also
 *
 * To learn about working with Search methods, see [API Query Language](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-the-wix-api-query-language) and [Sorting and Paging](https://dev.wix.com/docs/api-reference/articles/work-with-wix-apis/data-retrieval/about-sorting-and-paging).
 * @param search - Search criteria including filter, sort, aggregations, and paging options.
 * @public
 * @requiredField search
 * @permissionId BOOKINGS.SERVICES_READ
 * @applicableIdentity APP
 * @fqn wix.bookings.services.v2.ServicesService.SearchServices
 */
export declare function searchServices(
  search: CursorSearch
): Promise<SearchServicesResponse>;
